import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { LoginService } from "../services/login.service";
import { SharedService } from "../services/shared.service";

export const adminGuard: CanActivateFn = () => {
    const loginService = inject(LoginService);
    const sharedService = inject(SharedService);
    const router = inject(Router);

    const isLoggedIn = loginService.isLoggedIn();
    const superAdmin = sharedService.isUserSuperAdmin();

    if (isLoggedIn && superAdmin) {
        return true;
    } else {
        router.navigate(["home"]);
        return false;
    }
};
